import moment from "moment";
import ReactDatePicker from "react-datepicker"

interface IDayCalendarProps {
  startDate: Date | null | undefined;
  endDate: Date | null | undefined;
  onChange: (date: [Date | null, Date | null]) => void;
}

export const DayCalendar = ({ startDate, endDate, onChange}: IDayCalendarProps) => {
  return (
    <ReactDatePicker
      selected={startDate}
      onChange={(date) => onChange(date)}
      calendarStartDay={1}
      startDate={startDate}
      endDate={endDate}
      calendarClassName="!border-0"
      selectsRange
      inline
      disabledKeyboardNavigation
    />
  )
}